export default "__VITE_ASSET__DanTv8ig__"